import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddCountry from "./AddCountry";
import MainContainer from "../../components/container/MainContainer";
import LocationHeader from "../../components/header/LocationHeader";
import Table from "../../components/tables/Table";
import { openModal } from "../../features/modalSLice";
import Modal from "../../components/modal/Modal";
import { getCountries, unsetCountries } from "../../features/countriesSlice";
import Loading from "../../components/loading/Loading";
import loadStatus from "../../util/loadStatus";
import { useLocation } from "react-router-dom";
import NetworkError from "../error/NetworkError";

const Country = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const countries = useSelector((state) => state.countries.data);
  const loading = useSelector((state) => state.countries.load.getCountries);

  const links = [
    { to: "/communities", name: "Communities" },
    { to: "/regions", name: "Regions" },
  ];
  const columns = [
    { id: "id", text: "Num" },
    { id: "nice_name", text: "Name" },
    { id: "phone_code", text: "Phone" },
    { id: "num_code", text: "Code" },
    { id: "iso3", text: "Iso3" },
  ];
  //
  const openCountryModal = () => {
    dispatch(openModal(<AddCountry />));
  };

  //
  useEffect(() => {
    dispatch(getCountries());
    return () => {
      dispatch(unsetCountries());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.loading) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>
      <MainContainer>
        <LocationHeader
          links={links}
          title="Countries"
          action={openCountryModal}
        />
        <main className="table-container">
          <Table columns={columns} data={countries} />
        </main>
      </MainContainer>
    </>
  );
};

export default Country;
